import { css } from '@emotion/react';

export const recieptText = css({
    margin: 0,
    fontSize: '1.6rem',
    fontFamily: 'AcuminRPro',
});

export const homeBtn = css({
    '@media(min-width: 300px)': {
        display: 'flex',
        justifyContent: 'center',
        width: '96%',
        backgroundColor: '#064E72',
        color: 'white',
        borderRadius: 8,
        paddingTop: 16,
        paddingBottom: 16,
        '& p': {
            fontSize: '1.4rem',
            fontFamily: 'AcuminRPro',
            textAlign: 'center',
            margin: '0px',
        },
        '& img': {
            width: 20,
            height: 20,
            marginTop: -6,
            marginLeft: 10,
        },
    },
    '@media(min-width: 1200px)': {
        display: 'flex',
        justifyContent: 'center',
        width: '96%',
        backgroundColor: '#064E72',
        color: 'white',
        borderRadius: 8,
        paddingTop: 16,
        paddingBottom: 16,
        '& p': {
            fontSize: '1.4rem',
            fontFamily: 'AcuminRPro',
            textAlign: 'center',
            margin: '0px',
        },
        '& img': {
            width: 25,
            height: 25,
            marginTop: -3,
            marginLeft: 10,
        },
    },
});

export const container = css({
    '@media(min-width: 300px)': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        // height: '70vh',
        paddingTop: 100,
        '& .cont1': {

            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '90%',
        },
    },

    '@media(min-width: 1200px)': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 100,
        '& .cont1': {

            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '19.5%',
        },
    },

});

export const title = css({
    '@media(min-width: 300px)': {
        fontSize: '3rem',
        fontWeight: 700,
        margin: 0,
        marginTop: 20,
        paddingBottom: 20,
    },

    '@media(min-width: 1200px)': {
    },
});

export const titleRelated = css({
    '@media(min-width: 300px)': {
        fontSize: '3rem',
        fontWeight: 700,
        margin: 0,
        marginTop: 20,
        paddingBottom: 20,
    },

    '@media(min-width: 1200px)': {
        textAlign: 'start',
    },
});

export const text = css({
    '@media(min-width: 300px)': {
        margin: 0,
        textAlign: 'center',
        paddingBottom: 20,
        fontSize: '1.8rem',
        fontFamily: 'AcuminRPro',
    },

    '@media(min-width: 1200px)': {
        margin: 0,
        textAlign: 'center',
        paddingBottom: 20,
        fontSize: '1.4rem',
        fontFamily: 'AcuminRPro',
    },
});

export const textDetails = css({
    '@media(min-width: 300px)': {
        margin: 0,
        paddingBottom: 20,
        fontSize: '1.8rem',
        fontFamily: 'AcuminRPro',
    },

    '@media(min-width: 1200px)': {
        margin: 0,
        paddingBottom: 20,
        fontSize: '1.4rem',
        fontFamily: 'AcuminRPro',
    },
});

export const contRelated = css({
    '@media(min-width:300px)': {
        paddingTop: 100,
        paddingBottom: 20,
        paddingLeft: '10%',
        paddingRight: '10%',
        backgroundColor: 'white',
        border: '1px',
        borderWidth: 1,
        borderColor: '#d7d7d7',
        textAlign: 'center',
        marginTop: 10,
    },

    '@media(min-width:992px)': {
        paddingLeft: '15%',
        paddingRight: '15%',
    },

    '@media(min-width:1200px)': {
        paddingTop: 100,
        paddingBottom: 120,
        paddingLeft: '10%',
        paddingRight: '10%',
        backgroundColor: 'white',
        border: '1px',
        borderWidth: 1,
        borderColor: '#d7d7d7',
        textAlign: 'center',
        marginTop: 10,
    },
});
